// extracted by mini-css-extract-plugin
export default {"header":"JyKScRvf5GGgvIaGpSPT","list":"RjijJEc_3KPZyM2F_iup","tag":"WQJHGQNx5fp52sYEy5LK"};